import { alert } from "notie";

function showFileError() {
    const errorNode = document.querySelector("#file-error");
    if (errorNode) {
        alert({ type: "warning", text: errorNode.innerHTML, time: 2, position: "bottom" })
    }
}

function attachFileToForm() {
    const filenameNode = this.parentNode.querySelector(".file-name");
    if (!filenameNode) {
        console.error("There is no place to show filename.");
    }
    const size = this.files[0]['size'];
    let name = this.value.replace(/C:\\fakepath\\/, '');
    if (size > 10000000) {
        showFileError();
        name = 'UPLOAD'
        this.value = '';
        this.form.reset();
    }
    filenameNode.setAttribute('title', name);
    filenameNode.innerText = name;
}

[...document.querySelectorAll(".upload-button > .upload-input")].map((o) => o.addEventListener("change", attachFileToForm));
